type AuthorizedFetch = (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>;

const FALLBACK_FILENAME = "ca-certificate.crt";

const extractFilename = (contentDisposition: string | null): string | null => {
  if (!contentDisposition) {
    return null;
  }

  const utfMatch = /filename\*=UTF-8''([^;]+)/i.exec(contentDisposition);
  if (utfMatch && utfMatch[1]) {
    try {
      return decodeURIComponent(utfMatch[1]);
    } catch {
      // ignore decode errors and fall back to basic parsing
    }
  }

  const basicMatch = /filename="?([^\";]+)"?/i.exec(contentDisposition);
  if (basicMatch && basicMatch[1]) {
    return basicMatch[1];
  }

  return null;
};

export const downloadCaCertificate = async (authorizedFetch: AuthorizedFetch) => {
  const response = await authorizedFetch("/api/config/ca-cert", {
    method: "GET"
  });

  if (!response.ok) {
    let message = "Unable to download certificate";
    try {
      const payload = await response.json().catch(() => null) as { error?: unknown } | null;
      if (payload && typeof payload.error === "string") {
        message = payload.error;
      }
    } catch {
      // ignore JSON parse errors
    }
    throw new Error(message);
  }

  const blob = await response.blob();
  const suggestedName = extractFilename(response.headers.get("Content-Disposition"));
  const filename = suggestedName && suggestedName.trim() ? suggestedName.trim() : FALLBACK_FILENAME;
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};

export default downloadCaCertificate;
